import { lazy, type ReactElement, Suspense } from "react";
import type { ChartProps } from "./chart.js";

/**
 * Grafik kodunu (ECharts + zrender) SAYFAYA tembel yükler: ana paket ve rota parçası grafik kütüphanesini
 * taşımaz, kullanıcı grafiği olan bir bölüme geldiğinde indirilir. Yükleme sırasında yalnızca boş bir kap
 * çizilir — veriyi taşıyan tablo alternatifi zaten grafiğin yanındadır, bu yüzden bekleyen bir bilgi yoktur.
 */
const Chart = lazy(() => import("./chart.js"));

export type { ChartProps };

export function LazyChart({ height = 320, ...props }: ChartProps): ReactElement {
  return (
    <Suspense
      fallback={
        <div
          aria-hidden="true"
          className="animate-pulse rounded-md bg-muted"
          style={{ height: `${height}px` }}
        />
      }
    >
      <Chart {...props} height={height} />
    </Suspense>
  );
}
